import {EventCustomAction, EventCustomLabel, EventCustomParameters} from '_types'
import {analyticsEventCustom} from './event-custom'

interface Parameters {
    action: EventCustomAction
    label: EventCustomLabel
    accessType: string
}

/**
 * Tracks a quick cart add event triggered by the user.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {EventCustomAction} params.action - Action of the event.
 * @param {EventCustomLabel} params.label - Label of the event.
 * @param {string} params.accessType - Access type of the event.
 */
export function analyticsEventQuickCartAdd({action, label, accessType}: Parameters) {
    const eventDetails: EventCustomParameters = {
        accessType: accessType,
        category: 'Size Selector',
        buttonType: 'Quick Cart Add',
        action: action,
        label: label,
    }

    analyticsEventCustom(eventDetails)
}
